var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "wp-next-reviewer-modal",
      attrs: { modalType: _vm.modalType, className: "wp-nextreviewer-modal" },
    },
    [
      _vm._t("wp-next-reviewer-content"),
      _vm._v(" "),
      _c("label", { staticClass: "modal-lable required-flag" }, [
        _vm._v(_vm._s(_vm.labelContext)),
      ]),
      _vm._v(" "),
      _c("HKLSelect", {
        staticClass: "wp-next-reviewer-select",
        attrs: {
          value: _vm.payloadId || undefined,
          options: _vm.reviewerHklOptions,
          showSearch: true,
          required: true,
          placeholder: "",
        },
        on: { change: _vm.onReviewerChange },
      }),
      _vm._v(" "),
      _vm._t("additional-content"),
      _vm._v(" "),
      _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
        _c(
          "button",
          { staticClass: "btn btn--darkblue", on: { click: _vm.closeModal } },
          [_vm._v(_vm._s(_vm.noBtnContext))]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn btn--orange", on: { click: _vm.submit } },
          [_vm._v(_vm._s(_vm.okBtnContext))]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }